// extracted by mini-css-extract-plugin
module.exports = {"subheadline":"_3u4-Y"};